import Schedule1 from './schedule1';
import Schedule2 from './schedule2';
import Schedule3 from './schedule3';

const Schedules = {
  Schedule1,
  Schedule2,
  Schedule3,
};

export default Schedules;
